var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"internal-information-wrapper"},[_c('div',{staticClass:"internal-information container col-lg-10 col-sm-12"},[_c('h1',{staticClass:"pt-3 pb-3 mb-3"},[_vm._v("Internal Information")]),_c('InternalInformationSection',{attrs:{"validate":_vm.validate},on:{"change":_vm.handleChange,"valid":_vm.handleValidated}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }